import { QarepaEnumInformation } from '@qarepa/common';

export enum ScheduleTypeEnum {
  FIXED = 'FIXED',
  FLEXIBLE = 'FLEXIBLE',
  SHIFT = 'SHIFT',
}

export const ScheduleTypeArray = [
  ScheduleTypeEnum.FIXED,
  ScheduleTypeEnum.FLEXIBLE,
  ScheduleTypeEnum.SHIFT,
];

export const ScheduleTypeInfo: QarepaEnumInformation<ScheduleTypeEnum> = {
  [ScheduleTypeEnum.FIXED]: {
    name: $localize`Fijo`,
  },

  [ScheduleTypeEnum.FLEXIBLE]: {
    name: $localize`Flexible`,
  },

  [ScheduleTypeEnum.SHIFT]: {
    name: $localize`Turno`,
  },
};
